import { gsap } from 'gsap';

export { gsap };

export const prefersReducedMotion = () => (
  typeof window !== 'undefined'
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches
);

/**
 * Shared organogram / shell motion.
 * Soft sine curves, short travel, overlapping staggers — fade-led, not snappy.
 */
export const ORG_MOTION = {
  cameraFit: 0.85,
  cameraPan: 0.65,
  cameraZoom: 0.4,
  cameraEase: 'power2.out',
  flip: 0.55,
  flipEase: 'power1.inOut',
  flipEnter: 0.42,
  flipLeave: 0.28,
  panelIn: 0.55,
  panelOut: 0.36,
  panelEaseIn: 'sine.out',
  panelEaseOut: 'sine.in',
  panelSlideIn: 24,
  panelSlideOut: 16,
  /** Content load-in (lists, stat cards, drill rows). */
  list: 0.75,
  /** Total stagger window across all items (overlapping wave). */
  listStaggerAmount: 0.28,
  listEase: 'sine.out',
  listY: 6,
  breadcrumbIn: 0.36,
  breadcrumbStagger: 0.05,
  searchPanelIn: 0.4,
  searchPanelOut: 0.26,
  countUp: 0.9,
  countUpEase: 'sine.out',
  pageIn: 0.58,
  pageOut: 0.4,
  pageEaseIn: 'sine.out',
  pageEaseOut: 'sine.in',
  pageSlideIn: 8,
  pageSlideOut: 5,
};

/**
 * Events calendar motion — short, fade-led; respects prefers-reduced-motion callers.
 */
export const CALENDAR_MOTION = {
  monthIn: 0.42,
  monthOut: 0.28,
  monthEaseIn: 'sine.out',
  monthEaseOut: 'sine.in',
  monthSlide: 18,
  panelIn: 0.42,
  panelOut: 0.28,
  panelEaseIn: 'sine.out',
  panelEaseOut: 'sine.in',
  panelSlide: 20,
  chipIn: 0.48,
  chipStaggerAmount: 0.32,
  chipEase: 'sine.out',
  chipY: 4,
  legendIn: 0.32,
  legendOut: 0.22,
  legendEase: 'sine.out',
  list: 0.55,
  listStaggerAmount: 0.22,
  listY: 8,
  listEase: 'sine.out',
};
